// extracted by mini-css-extract-plugin
module.exports = {"ListMapWrapper":"PigDetailsPage_ListMapWrapper__2xt0-","HeaderWrapper":"PigDetailsPage_HeaderWrapper__2ze2U"};